import '@/components/common/css/login/login.css';
import {phoneReg} from '../../../common/libs/common.js';
import api from '../../../common/libs/api.js';
import localforage from 'localforage';
import {mapState} from 'vuex';
import CityCodeData from '@/common/libs/CityCodeData';
import utils from '../../../common/libs/utils.js';
import '@/components/common/css/common.css';
import _ from 'lodash';

export default{
  name: 'Login',
  data() {
    return {
      smsLogin: this.$route.query.passwordLogin !== 1,
      sendCode: true,
      reSendCode: false,
      phone: '',
      code: '',
      password: '',
      passwordType: 'password',
      codeNum: 60,
      phoneRight: false,
      smsContent: {},
      phoneNoRegist: false,
      smsLoginNow: false,
      passwordLoginNow: false,
      codeImg: '',
      smsCodeImg: '',
      captcha: '',
      smsCaptcha: '',
      wechat: '',
      isInWechat: false,
      loginIcon: {},
      resetDialog: false,
      resetMessage: '',
      loginMethod: true
    };
  },
  computed: mapState({
    network: state => state.home.network,
    city: state => state.home.city
  }),
  watch: {
    // 监测网络情况，对断网进行处理
    network: {
      handler: function(newVal) {
        if (!newVal) {
          this.passwordLoginNow = false;
          this.smsLoginNow = false;
        }
      }
    },
    city: {
      handler: function() {
        this.setTitle();
      },
      deep: true
    }
  },
  metaData({store, route}) {
    let city = CityCodeData.getCityByShort(route.params.city);

    store.dispatch('setMeta', {
      title: `欢迎登录学而思爱智康用户系统_${city.city_name}学而思爱智康`,
      description: `${city.city_name}学而思爱智康官网提供小学、初中、高中一对一个性化辅导课程,涵盖各年级学科1对1、小组课和在线课程,专业教师团队满足不同学生需求,咨询电话：400-810-2680`,
      keywords: `学而思爱智康,学而思爱智康官网,智康一对一,学而思爱智康一对一,${city.city_name}学而思爱智康官网`
    });
  },
  methods: {
    changeTab(smsLogin) {
      this.smsLogin = smsLogin;
      if (phoneReg.test(this.phone)) {
        this.phoneRight = true;
      } else {
        this.phoneRight = false;
      }
      // if (smsLogin) {
      //   this.smsGetCodeImg();
      // } else {
      //   this.getCodeImg();
      // }
    },
    goHome() {
      this.$router.push({name: 'Home'});
    },
    cancelReset(){
      this.resetDialog =false;
    },
    goProtocol() {
      this.$router.push({name: 'protocol'});
    },
    goSecret(){
      this.$router.push({name: 'secret'});
    },
    input() {
      if (phoneReg.test(this.phone)) {
        this.phoneRight = true;
      } else {
        this.phoneRight = false;
      }

    },
    timer() {
      let vm = this;

      let timer = setInterval(function() {
        if (vm.codeNum == 1) {
          clearInterval(timer);
          timer = null;
          vm.codeNum = 60;
          vm.reSendCode = true;
        } else {
          vm.codeNum--;
        }
      }, 1000);
    },
    send() {
      let vm = this;

      if (!this.phoneRight) {
        return;
      }

      this.reSendCode = false;
      this.sendCode = false;
      this.timer();
      let data = {
        phone_code: '86',
        phone: this.phone
      };
      var params = {
       data,
       success: function (res) {
           if (res.errcode == 11021) {
            // 需要展示滑块
            // 滑块验证的逻辑是滑动验证通过后，SDK再次调用之前的方法，与后端交互，通过success回调返回这次操作的结果，故需要将方法名和之前的入参数据作为showSlide的参数。
            var param = {
                slideCallback: 'sendSMSCodeLogin', // 滑动验证通过时执行方法名，（即触发滑块的原方法，例如：登录（loginSms），获取验证码（sendSmsCodeLogin），校验旧手机（checkPhone））
                slideParams: params, // 前端滑动验证通过时执行方法名的参数（例如手机号，验证码,success和fail等等）
                failCallback: function (error) {
                    vm.$store.dispatch('toast', {title: error.errmsg, show: true});
                } // 方法名出错
            }
            // 展示滑块
            TAL_UC.showSlide(param)
            return
        } else if (res.errcode == 0){
            vm.$store.dispatch('toast', {title: '已发送验证码到您的手机，请注意查收', show: true});
        } else {
          vm.$store.dispatch('toast', {title: res.errmsg, show: true});
        }
       },
       fail: function (error) {
        vm.$store.dispatch('toast', {title: error.errmsg, show: true});
       }
      }
      TAL_UC.sendSMSCodeLogin(params)
    },
    bury(name) {
      let stater = this.$store.state;
      let obj = {
        'login_type': name || '短信登录',
        'user_tel_no': this.phone,
        'locate_city': stater.home.city.city_name,
        'user_grade': stater.course.grade.name || ''
      };

      utils.bury('yd_izhikang_user_login', obj);
    },
    login() {
      let vm = this;
      utils.cookie.del('token', '.izhikang.com', '/');
      localStorage.removeItem('token');
      if (this.phone.length === 0) {

        this.$store.dispatch('toast', {title: '请输入手机号码', show: true});
        return;
      }
      if (!this.phoneRight) {

        this.$store.dispatch('toast', {title: '请输入正确格式的11位手机号', show: true});
        return;
      }
      if (this.code.length == 0) {

        this.$store.dispatch('toast', {title: '请输入正确的验证码', show: true});
        return;
      }

      vm.smsLoginNow = true;

      this.bury('短信登录', {
        'from': this.$route.query.name || ''
      });
      let data = {
        // phone: this.phone,
        // sms_code: this.code,
        // type: 'sms',
        // captcha: this.smsCaptcha,
        // function_type: 1,
        phone: this.phone,
        phone_code: 86,    // 手机地区码
        sms_code: this.code   // 短信验证码
      };
      var params={
        data,
        success: function(res){
          if (res.errcode == 11021) {
            // 需要展示滑块
            // 滑块验证的逻辑是滑动验证通过后，SDK再次调用之前的方法，与后端交互，通过success回调返回这次操作的结果，故需要将方法名和之前的入参数据作为showSlide的参数。
            vm.smsLoginNow = false;
            var slideParam = {
                slideCallback: 'loginSms', // 滑动验证通过时执行方法名，（即触发滑块的原方法，例如：登录（loginSms），获取验证码（sendSmsCodeLogin），校验旧手机（checkPhone））
                slideParams: params, // 前端滑动验证通过时执行方法名的参数（例如手机号，验证码,success和fail等等）
                failCallback: function (error) {
                    vm.$store.dispatch('toast', {title: error.errmsg, show: true});
                } // 方法名出错
            }
            // 展示滑块
            TAL_UC.showSlide(slideParam)
            // that.loginLoading = false;
            return
          } else if (res.errcode == 0){
            vm.loginExchangeToken(res);
          } else {
            vm.smsLoginNow = false;
            vm.$store.dispatch('toast', {title: res.errmsg, show: true});
          }
        },
        fail: function(res){
          vm.smsLoginNow = false;
          vm.$store.dispatch('toast', {title: res.errmsg, show: true});
        }
      }
      TAL_UC.loginSms(params);
    },
    loginExchangeToken(changeRes){
      var vm = this;
      api.apiMethod.login.post({code: changeRes.data.code}).then(res => {
        this.smsLoginNow = false;
        if (res.data.code == 0&&_.isObject(res.data.data)) {
          localStorage.setItem('token', res.data.data.token);
          utils.cookie.set('token', res.data.data.token, '.izhikang.com', '/', 24*7);
          localforage.setItem('token', res.data.data.token);
          localforage.setItem('izk-user', res.data.data);
          vm.$store.commit('addMine', {state: res.data.data});
          vm.$store.dispatch('toast', {title: '登录成功', show: true});
          vm.getStudentCardInfo();
        } else {
          console.log('登录返回：', res.data);
          utils.cookie.del('token', '.izhikang.com', '/');
          localStorage.removeItem('token');
          localforage.removeItem('token');
          localforage.removeItem('izk-user');
          vm.$store.dispatch('toast', {title: res.data.msg, show: true});
          // vm.smsGetCodeImg();
        }
      });
    },
    loginNow() {
      let vm = this;
      utils.cookie.del('token', '.izhikang.com', '/');
      localStorage.removeItem('token');
      /* 解决低版本ios设备键盘弹出后无法关闭弹窗问题 start */
      window.scrollBy(1, 2);
      /* 解决低版本ios设备键盘弹出后无法关闭弹窗问题 end */
      if (this.phone.length === 0) {

        this.$store.dispatch('toast', {title: '请输入手机号码', show: true});
        return;
      }
      if (!phoneReg.test(this.phone)) {

        this.$store.dispatch('toast', {title: '请输入正确格式的11位手机号', show: true});
        return;
      }
      if (this.password.length === 0) {

        this.$store.dispatch('toast', {title: '手机号或密码错误', show: true});
        return;
      }
      if (this.password.length < 6 || this.password.length > 18) {

        this.$store.dispatch('toast', {title: '密码填写错误', show: true});
        return;
      }

      vm.passwordLoginNow = true;

      this.bury('密码登录', {
        'from': this.$route.query.name || ''
      });

      let data = {
        symbol: this.phone,
        password: this.password
      };
      //对接集团用户中心新的密码登录方式
      var params={
        data,
        success: function(res){
          if (res.errcode == 11021) {
            // 需要展示滑块
            // 滑块验证的逻辑是滑动验证通过后，SDK再次调用之前的方法，与后端交互，通过success回调返回这次操作的结果，故需要将方法名和之前的入参数据作为showSlide的参数。
            var slideParam = {
                slideCallback: 'loginPassword', // 滑动验证通过时执行方法名，（即触发滑块的原方法，例如：登录（loginSms），获取验证码（sendSmsCodeLogin），校验旧手机（checkPhone））
                slideParams: params, // 前端滑动验证通过时执行方法名的参数（例如手机号，验证码,success和fail等等）
                failCallback: function (error) {
                    vm.$store.dispatch('toast', {title: error.errmsg, show: true});
                } // 方法名出错
            }
            // 展示滑块
            TAL_UC.showSlide(slideParam)
            return
          } else if (res.errcode == 0){
            vm.loginNowExchangeToken(res);
          } else if (res.errcode == 11048){
            vm.resetDialog = true;
            vm.resetMessage = res.errmsg;
            vm.loginMethod = true;
          } else if (res.errcode == 11049){
            vm.resetDialog = true;
            vm.resetMessage = res.errmsg;
            vm.loginMethod = false;
          } else if (res.errcode == 11039){
            vm.resetDialog = true;
            vm.resetMessage = res.errmsg;
            vm.loginMethod = false;
          } else {
            vm.$store.dispatch('toast', {title: res.errmsg, show: true});
          }
          vm.passwordLoginNow = false;
        },
        fail: function(res){
          vm.$store.dispatch('toast', {title: res.errmsg, show: true});
          vm.passwordLoginNow = false;
        }
      }
      TAL_UC.loginPassword(params);
    },
    loginNowExchangeToken(changeRes){
      var vm = this;
      api.apiMethod.login.post({code: changeRes.data.code}).then(res => {
        if (res.data.code === 0) {
          localStorage.setItem('token', res.data.data.token);
          utils.cookie.set('token', res.data.data.token, '.izhikang.com', '/', 24*7);
          localforage.setItem('token', res.data.data.token);
          localforage.setItem('izk-user', res.data.data);

          vm.$store.commit('addMine', {state: res.data.data});
          vm.$store.dispatch('toast', {title: '登录成功', show: true});
          vm.getStudentCardInfo();
        } else if (res.data.code == 20005) {
          vm.phoneNoRegist = true;
        } else {
          utils.cookie.del('token', '.izhikang.com', '/');
          localStorage.removeItem('token');
          localforage.removeItem('token');
          localforage.removeItem('izk-user');
          console.log('登录返回：', res.data);
          vm.$store.dispatch('toast', {title: res.data.msg, show: true});
          // vm.getCodeImg();
        }
      });
    },
    getIcon() {
      let vm = this;
      let obj = {
        type: 'login'
      };

      api.apiMethod.getLoginIcon.post(obj).then(res => {
        vm.loginIcon = res.data.content.list[0];
      });
    },
    cancel() {
      this.phoneNoRegist = false;
    },
    toSmsLogin() {
      this.phoneNoRegist = false;
      this.smsLogin = true;
    },
    forget() {
      this.$router.push({name: 'phone', query: this.$route.query});
    },
    changeLogin(){
      this.smsLogin = true;
      this.resetDialog = false;
    },
    showOrHidePassword() {
      this.passwordType = this.passwordType == 'password' ? 'text' : 'password';
    },
    setTitle() {
      if (!this.city.open_city) {
        document.title = '欢迎登录学而思爱智康用户系统_学而思爱智康';

        return;
      }
      document.title = `欢迎登录学而思爱智康用户系统_${this.city.city_name}学而思爱智康`;
    },
    //获取学员卡信息
    getStudentCardInfo() {
      this.$store.commit('isShowLoading', true);
      api.apiMethod.getStudentCardInfo.get().then(res => {  
        this.$store.commit('isShowLoading', false);
        if (res.data.errcode == 0) {
            let info = res.data.data;
            if (info.cityCode && info.cityCode.length != 0 && info.cityCode != '0086') { //学员卡城市为空或是其他
              utils.cookie.set('cityCode', info.cityCode, '.izhikang.com', '/', 24*7);
              utils.cookie.set('cardChangeCity', 1, '.izhikang.com', '/', 24*7);
            } else {
              let routerCity = CityCodeData.getCityByShort(this.$route.params.city);
              utils.cookie.set('cityCode', routerCity.city_code, '.izhikang.com', '/', 24*7);
              utils.cookie.set('cardChangeCity', 0, '.izhikang.com', '/', 24*7);
            }
            utils.cookie.set('canSwitchCity', info.canSwitchCity, '.izhikang.com', '/', 24*7);
            
            //从详情页等跳转过来
            if (this.$route.query && Object.keys(this.$route.query).length != 0) { 
              if (this.$route.query.query && typeof(this.$route.query.query) == 'string' && this.$route.query.query.length != 0) {
                this.$route.query.query = utils.serializerToJson(this.$route.query.query)
              }
              if (this.$route.query.params && typeof(this.$route.query.params) == 'string' && this.$route.query.params.length != 0) {
                this.$route.query.params = utils.serializerToJson(this.$route.query.params)
              }
              console.log('登录成功跳转：', this.$route.query);
              this.$router.replace(this.$route.query);
            } else {
              let cookieCity = CityCodeData.getCityByCode(utils.cookie.get('cityCode'));
              this.$store.commit('setCity', cookieCity);
              this.$router.push({
                name: 'mine',
                params: {
                  city: cookieCity.first_word
                }
              });
            }
        } else {
          this.$store.dispatch('toast', { title: res.data.msg, show: true });
        }
      });
    }
  },
  mounted() {
    this.setTitle();
    console.log(this.$route.query);
    this.wechat = `${api.getServer() }/izk/index.php/wxpay/get_wx_user_info`;
    this.$store.commit('isShowHeader', {isShowHeader: false});
    this.$store.commit('isShowFooter', {isShowFooter: false});
    this.getIcon();
    // this.getCodeImg();
    // this.smsGetCodeImg();
    // this.isInWechat = isWeChat(navigator);  //微信登录，暂时去掉
    let stater = this.$store.state;
    let obj = {
      'page_name': '登录页面',
      'locate_city': this.city.city_name,
      'user_grade': stater.course.grade.name || '三年级',
      'from': this.$route.query.name || ''
    };
    let query = this.$route.query.query
    if (query) {
      let productId = utils.getParameter('productId', query)
      let channel = utils.getParameter('channel', query)
      obj.productId = productId
      obj.channel = channel
    }
    
    utils.bury('yd_izhikang_page_browse', obj);
  }
};


// WEBPACK FOOTER //
// ./src/components/mine/login/LoginVM.js